import React from 'react';
import styles from './Relations.module.scss';
import { SchemaRelationTypeGroup } from '../../interfaces/schemaRelations';
import { NodeLogo } from '@hevoio/hevo-ui-toolkit';
import RoundedIcon from '../../../../media/components/rounded-icon/RoundedIcon';

function Relations({ relationGroup }: { relationGroup: SchemaRelationTypeGroup }) {
  return (
    <div className={styles.wrapper}>
      {relationGroup.meta.iconName ? (
        <RoundedIcon
          iconName={relationGroup.meta.iconName}
          containerSize={4}
          isIconColorWhite={false}
          hasBg={false}
          hasBorder
          className='mr-3 mb-1'
        />
      ) : (
        <NodeLogo
          roundedBorders
          size={5}
          logoURL={relationGroup.meta.logoUrl}
          darkModeLogoURL={relationGroup.meta.darkModeLogoUrl}
          primaryColor={relationGroup.meta.logoPrimaryColor}
          darkModePrimaryColor={relationGroup.meta.darkModePrimaryColor}
          className='mr-3 mb-1'
        />
      )}

      <div className={styles.rdDetails}>
        <div className={styles.rdCaption}>{relationGroup.meta.typeDisplay}</div>

        {relationGroup.relationNames.map(relationName => (
          <div key={relationName} className={styles.rdEntities}>
            {relationName}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Relations;
